module.exports = __webpack_public_path__ + "img/payment_failed.99ae1c47.png";